// eslint-disable-next-line import/no-anonymous-default-export
export default (
  state = {
    btnLoader: false,
    loginUser: null,
    secondaryPermissions: [],
    secondaryPermissionsRoles: [],
    // registerUser: null,
    certificates: [],
    showCompanySelectionModal: false,
    isComingFromStock:false,
    isOnboardingBuyer:false,
    isPaint:false,
    is_PWA: false
  },
  action,
) => {
  switch (action.type) {
    case 'SHOW_LOADER':
      return { ...state, btnLoader: true };
    case 'HIDE_LOADER':
      return { ...state, btnLoader: false };
    case 'SET_USER':
      return { ...state, loginUser: action.data };
    case 'SET_SECONDARY_PERMISSION':
      return { ...state, secondaryPermissions: action.data };
    case 'SET_SECONDARY_PERMISSION_ROLES':
      return { ...state, secondaryPermissionsRoles: action.data };
    case 'SET_CERTIFICATES':
      return { ...state, certificates: action.data };
    // case 'SET_REGISTER_USER':
    //     return {...state, registerUser: action.data}
    case 'LOGOUT':
      return { ...state, loginUser: null };
    case 'SHOW_COMPANY_SELECTION_MODAL': {
        return {
          ...state,
          showCompanySelectionModal: action.showCompanySelectionModal,
        };
    }
    case 'IS_COMING_FROM_STOCK':
      return { ...state, isComingFromStock: action.isComingFromStock };
    case 'SET_IS_ONBOARDING_BUYER':
      return { ...state, isOnboardingBuyer: action.isOnboardingBuyer };  
    case 'SET_IS_PAINT':
      return { ...state, isPaint: action.isPaint };
    case 'SET_IS_PWA':
      return { ...state, is_PWA: action.is_PWA };
    default:
      return state;
  }
};
